import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from "lodash";
import React, { useState } from "react";
import { useEffect } from "react";
import { TableControl } from "../../../../components/controls";
import { FormatUTCDate } from "../../../../utilities/DateFormater";



const DistrictTable = ({ filteredItems, onEdit, onDelete, onDrillDown, isDrilledDown }) => {
    const [rows, setRows] = useState([]);
    const [columns] = useState([
        {
            header: "Organization Name",
            dataProp: "OrganizationName",
            width: '30%',
            canSort: true,
            hideData: isDrilledDown && true
        },
        {
            header: 'District Name',
            dataProp: "Name",
            width: '30%',
            canSort: true
        },

        {
            header: 'District Number',
            dataProp: 'DistrictNumber',
            width: '25%',
            canSort: true
        }, {
            header: 'District Only Content?',
            dataProp: 'DistrictOnlyContent',
            width: '20%',
            datatype: 'bool',
            isBool: true,
            canSort: true
        }, {
            header: 'Active?',
            dataProp: 'IsActive',
            width: '10%',
            datatype: 'bool',
            canSort: true
        },

        {
            header: 'Created Date',
            dataProp: 'CreatedDate',
            width: '20%',
            datatype: 'dateTime',
            canSort: true
        }
    ]);


    useEffect(() => {
        let newRows = [];
        if (filteredItems) {
            _.each(filteredItems, (c) => {
                newRows.push({
                    ...c,
                    CreatedDate: FormatUTCDate(c.CreatedDate),
                    OrganizationName: c?.Organization?.Name,
                });
            });
            setRows(newRows);
        }
    }, [filteredItems]);

    return <>
        <div className="contentDisplay-list">
            <TableControl
                columns={columns}
                data={rows}
                permission='District'
                useIntegratedPaging={['10', '25', '50', '100']}
                onEdit={onEdit}
                onDelete={onDelete}
                onCustom1={{ action: (row) => <FontAwesomeIcon className={'btn-icon-fa'} title="View Associated Schools" icon={faArrowDown} onClick={() => onDrillDown(row)} /> }}
            />
        </div>
    </>
}

export default DistrictTable;